export const CONFIRM_DELETE =
  "Do you wish to delete this Scheduled Bulletin? Deleting a Scheduled Bulletin means it will no longer be sent on the scheduled date and the Bulletin content will be erased.";

export const DELETE_TITLE = "Delete Scheduled Bulletin";
